export const Passive = {
  passive: true,
}

export const Active = {
  passive: false,
}

export const Capture = {
  capture: true,
}
